import { __assign } from "tslib";
import { getCurrentHub } from '@hy-sentry/hub';
import { Dsn, getGlobalObject, logger, supportsFetch, SyncPromise } from '@hy-sentry/utils';
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
export function initAndBind(clientClass, options) {
    if (options.debug === true) {
        logger.enable();
    }
    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function (search, rawPos) {
                // eslint-disable-next-line no-bitwise
                var pos = rawPos > 0 ? rawPos | 0 : 0;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return this.substring(pos, pos + search.length) === search;
            },
        });
    }
    // 如果不需要远程控制，则直接执行原逻辑
    if (options.disableRemoteStaticControl) {
        var hub = getCurrentHub();
        var scope = hub.getScope();
        if (scope) {
            scope.update(options.initialScope);
        }
        var client = new clientClass(options);
        hub.bindClient(client);
        return;
    }
    /**
     * 执行缓存逻辑后再执行原方案，这里执行缓存逻辑是避免客户端对配置文件进行缓存导致配置不生效
     * @param opts
     */
    function bindAsOrigin(opts) {
        if (opts === void 0) { opts = {}; }
        var rOpts = opts;
        try {
            var window_1 = getGlobalObject();
            // opts 更新则写入缓存，有值则写入
            if (opts && Object.keys(opts).length > 0) {
                window_1.localStorage.setItem('rateConfWithSDK', JSON.stringify(opts));
            }
            else {
                var crt = window_1.localStorage.getItem('rateConfWithSDK');
                if (crt && crt !== '') {
                    rOpts = JSON.parse(crt);
                }
            }
        }
        catch (error) {
            rOpts = {};
        }
        finally {
            // fix: 无痕模式下 localstorage 报错
            var hub = getCurrentHub();
            var scope = hub.getScope();
            if (scope) {
                scope.update(options.initialScope);
            }
            var client = new clientClass(__assign(__assign({}, options), rOpts));
            hub.bindClient(client);
        }
    }
    /**
     * 返回 oss 地址
     */
    function genRemoteUrlFromOptions(options) {
        if (!options.dsn) {
            logger.error("Missing dsn option in showReportDialog call");
            return '';
        }
        var dsnObj = new Dsn(options.dsn);
        var key = dsnObj.publicKey;
        return "https://static-jw.msstatic.com/hy-sentry/options/" + key + ".json";
    }
    try {
        // 因为 DSN 对象需要结合 options 初始化，此时需要自己解析
        var url_1 = genRemoteUrlFromOptions(options);
        if (url_1 === '') {
            bindAsOrigin();
            return;
        }
        if (supportsFetch()) {
            void new SyncPromise(function () {
                void fetch(url_1).then(function (response) {
                    if (response.ok) {
                        void response
                            .json()
                            .then(function (res) {
                            if (res && res !== null && typeof res === 'object') {
                                bindAsOrigin(res);
                            }
                            else {
                                bindAsOrigin();
                            }
                        })
                            .catch(function () {
                            bindAsOrigin();
                        });
                    }
                    else {
                        bindAsOrigin();
                    }
                });
            }).then(undefined, function () {
                bindAsOrigin();
            });
        }
        else {
            void new SyncPromise(function () {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        // 判断 response 是否有效，排除 xml 的返回数据
                        if (!!request.response &&
                            typeof request.response === 'string' &&
                            typeof request.response.startsWith === 'function' &&
                            !request.response.startsWith('<?xml')) {
                            var res = JSON.parse(request.response);
                            bindAsOrigin(res);
                        }
                        else {
                            bindAsOrigin();
                        }
                    }
                    else {
                        bindAsOrigin();
                    }
                };
                request.open('GET', url_1);
                request.send();
            }).then(undefined, function () {
                bindAsOrigin();
            });
        }
    }
    catch (error) {
        bindAsOrigin();
    }
}
//# sourceMappingURL=sdk.js.map